/**
 * Navigation sidebar component.
 * Shows links to Dashboard, Modules, and Settings (admin only).
 * Displays current user info at the bottom.
 */

import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdmin } from '../utils/permissions';

export default function Sidebar() {
  const { user } = useAuth();

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h1 className="sidebar-logo">🏠 Homebase</h1>
      </div>

      <nav className="sidebar-nav">
        <NavLink to="/" className="nav-link" end>
          <span className="nav-icon">📊</span>
          <span className="nav-label">Dashboard</span>
        </NavLink>

        <NavLink to="/cashflow" className="nav-link">
          <span className="nav-icon">💰</span>
          <span className="nav-label">CashFlow</span>
        </NavLink>

        <NavLink to="/modules" className="nav-link">
          <span className="nav-icon">🧩</span>
          <span className="nav-label">Modules</span>
        </NavLink>

        {user && isAdmin(user.role) && (
          <NavLink to="/settings" className="nav-link">
            <span className="nav-icon">⚙️</span>
            <span className="nav-label">Settings</span>
          </NavLink>
        )}
      </nav>

      <div className="sidebar-footer">
        {user && (
          <div className="user-info">
            <div className="user-avatar">{user.name.charAt(0).toUpperCase()}</div>
            <div className="user-details">
              <div className="user-name">{user.name}</div>
              <div className="user-role">{user.role}</div>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}
